import {
  AgentsLogo,
  AiPercentageDetectorLogo,
  AirtableLogo,
  ApifyLogo,
  ApolloLogo,
  AsanaLogo,
  AttioLogo,
  BacklinksIcon,
  CalendlyLogo,
  CleanlistLogo,
  CloseLogo,
  ZoominfoLogo,
  DiscordLogo,
  FcpEuroLogo,
  FirecrawlLogo,
  FirmableLogo,
  DeepgramLogo,
  GammaLogo,
  GitHubLogo,
  GlassdoorLogo,
  GoogleLogo,
  GoogleSheetsLogo,
  GoogleShoppingLogo,
  GoogleMapsLogo,
  HackerNewsLogo,
  HunterLogo,
  HeyReachLogo,
  HexLogo,
  HubspotLogo,
  HyperspellLogo,
  InstagramLogo,
  InstantlyLogo,
  IntercomLogo,
  LemlistLogo,
  KlaviyoLogo,
  KustomerLogo,
  LinearLogo,
  LinkedInLogo,
  LoopsLogo,
  MatikLogo,
  NewsApiLogo,
  NewsCatcherLogo,
  NotionLogo,
  OrshotLogo,
  ParticlLogo,
  PerplexityLogo,
  PipedriveLogo,
  PoshmarkLogo,
  PostHogLogo,
  SalesforceLogo,
  SentryLogo,
  SimilarWebLogo,
  SkioLogo,
  SlackLogo,
  MicrosoftTeamsLogo,
  SmartleadLogo,
  TrustpilotLogo,
  TwilioLogo,
  TwitterLogo,
  UtilitiesLogo,
  VapiLogo,
  YouTubeLogo,
  ZendeskLogo,
  ZillowLogo,
  DixaLogo,
  ShopifyLogo,
  DevinLogo,
  FlightSearchLogo,
  RedditLogo,
  RampLogo,
  StripeLogo,
  ConfluenceLogo,
  JiraLogo,
  CoteraLogo,
  CrunchbaseLogo,
  DocSpringLogo,
  SnagSolutionsLogo,
  NashLogo,
  SpritesLogo,
  SnowflakeCortexIcon,
  BigQueryColorIcon,
  SupabaseLogo,
  TelegramLogo,
  TikTokLogo,
  ModalLogo,
  OceanLogo,
  TurbopufferLogo,
  SamGovLogo,
  SecLogo,
  SkyvernLogo,
  SmartyLogo,
  RealityDefenderLogo,
  FacebookReviewsLogo,
  SproutSocialLogo,
  G2Logo,
  GongLogo,
  GorgiasLogo,
  AppReviewsLogo,
  VitallyLogo,
  FirefliesLogo,
  MondayLogo,
  GrainLogo,
  GranolaLogo,
  RedashLogo,
  RetoolLogo,
  SigmaLogo,
  MicrosoftLogo,
  TavilyLogo,
  WeatherLogo,
  ZoomLogo,
  BufferLogo,
  WebflowLogo,
  QuoLogo,
  BomboraLogo,
  BuiltWithLogo,
  ExaLogo,
  ZeroBounceLogo,
} from '@cotera/client/app/components';
import {
  Headphones,
  Target,
  Share2,
  BarChart3,
  Globe,
  FileText,
  MessageSquareMore,
  Star,
  Calendar,
  Code,
  MapPin,
  Briefcase,
  Shield,
  Search,
  Database,
  type LucideIcon,
} from 'lucide-react';
import React from 'react';

export const PROVIDER_ICONS: Record<string, React.ComponentType> = {
  // Tools-v2 keys (kebab-case and mixed)
  'ai-detector': AiPercentageDetectorLogo,
  agents: AgentsLogo,
  airtable: AirtableLogo,
  // Placeholder until we add an Amdahl brand mark — the generic bot the agents
  // provider uses, rather than a broken image.
  amdahl: AgentsLogo,
  apify: ApifyLogo,
  apollo: ApolloLogo,
  asana: AsanaLogo,
  cleanlist: CleanlistLogo,
  close: CloseLogo,
  zoominfo: ZoominfoLogo,
  attio: AttioLogo,
  'app-reviews': AppReviewsLogo,
  appReviews: AppReviewsLogo,
  backlinks: BacklinksIcon,
  bombora: BomboraLogo,
  builtwith: BuiltWithLogo,
  exa: ExaLogo,
  zerobounce: ZeroBounceLogo,
  calendly: CalendlyLogo,
  coco: CoteraLogo,
  confluence: ConfluenceLogo,
  cotera: CoteraLogo,
  'cotera-included-tools': CoteraLogo,
  crunchbase: CrunchbaseLogo,
  coteraincludedtools: CoteraLogo,
  // The same icon a dataset resource carries everywhere else in the product,
  // rather than the generic Cotera mark every first-party tool used to share.
  dataset: Database,
  devin: DevinLogo,
  discord: DiscordLogo,
  dixa: DixaLogo,
  docspring: DocSpringLogo,
  'facebook-reviews': FacebookReviewsLogo,
  g2: G2Logo,
  gong: GongLogo,
  gorgias: GorgiasLogo,
  grain: GrainLogo,
  granola: GranolaLogo,
  jira: JiraLogo,
  'fcp-euro': FcpEuroLogo,
  fcpeuro: FcpEuroLogo,
  firecrawl: FirecrawlLogo,
  firmable: FirmableLogo,
  deepgram: DeepgramLogo,
  flightSearch: FlightSearchLogo,
  gamma: GammaLogo,
  github: GitHubLogo,
  glassdoor: GlassdoorLogo,
  google: GoogleLogo,
  'google-jobs': GoogleLogo,
  'google-keyword': GoogleLogo,
  'google-ads': GoogleLogo,
  'google-analytics': GoogleLogo,
  'google-search-console': GoogleLogo,
  'google-maps': GoogleMapsLogo,
  'google-sheets': GoogleSheetsLogo,
  'google-shopping': GoogleShoppingLogo,
  'google-workspace': GoogleLogo,
  'microsoft-365': MicrosoftLogo,
  microsoft365: MicrosoftLogo,
  googlejobs: GoogleLogo,
  googleJobs: GoogleLogo,
  googlemaps: GoogleMapsLogo,
  googlesearch: GoogleLogo,
  googlesheets: GoogleSheetsLogo,
  googleworkspace: GoogleLogo,
  'hacker-news': HackerNewsLogo,
  hunter: HunterLogo,
  heyreach: HeyReachLogo,
  hex: HexLogo,
  hubspot: HubspotLogo,
  hyperspell: HyperspellLogo,
  instagram: InstagramLogo,
  instantly: InstantlyLogo,
  intercom: IntercomLogo,
  lemlist: LemlistLogo,
  klaviyo: KlaviyoLogo,
  kustomer: KustomerLogo,
  linear: LinearLogo,
  linkedin: LinkedInLogo,
  loops: LoopsLogo,
  matik: MatikLogo,
  modal: ModalLogo,
  // Modal Sandbox is a separate provider group (its own tool keys, no
  // override in `providerForToolKey`), so it needs its own entry to reuse
  // Modal's mark rather than falling through to a blank icon.
  'modal-sandbox': ModalLogo,
  monday: MondayLogo,
  nash: NashLogo,
  newsapi: NewsApiLogo,
  newscatcher: NewsCatcherLogo,
  'newscatcher-catchall': NewsCatcherLogo,
  newscatchercatchall: NewsCatcherLogo,
  notion: NotionLogo,
  ocean: OceanLogo,
  'openai-finetune': AgentsLogo,
  openaifinetune: AgentsLogo,
  // Placeholder until we add an Orb brand mark — the generic bot the agents
  // provider uses, rather than a broken image.
  orb: AgentsLogo,
  orshot: OrshotLogo,
  particl: ParticlLogo,
  perplexity: PerplexityLogo,
  pipedrive: PipedriveLogo,
  posthog: PostHogLogo,
  poshmark: PoshmarkLogo,
  ramp: RampLogo,
  redash: RedashLogo,
  reddit: RedditLogo,
  // Placeholder until Regulation Asia give us a brand mark — the generic
  // bot the agents provider uses, rather than a broken image.
  'regulation-asia': AgentsLogo,
  retool: RetoolLogo,
  salesforce: SalesforceLogo,
  'sam-gov': SamGovLogo,
  sec: SecLogo,
  sentry: SentryLogo,
  'search-api': Search,
  searchApi: Search,
  shopify: ShopifyLogo,
  sigma: SigmaLogo,
  similarweb: SimilarWebLogo,
  skio: SkioLogo,
  skyvern: SkyvernLogo,
  slack: SlackLogo,
  slacksearch: SlackLogo,
  'microsoft-teams': MicrosoftTeamsLogo,
  smartlead: SmartleadLogo,
  smarty: SmartyLogo,
  'snag-solutions': SnagSolutionsLogo,
  snagsolutions: SnagSolutionsLogo,
  'sprout-social': SproutSocialLogo,
  sproutsocial: SproutSocialLogo,
  'snowflake-cortex': SnowflakeCortexIcon,
  snowflakeCortex: SnowflakeCortexIcon,
  'snowflake-sql': SnowflakeCortexIcon,
  'bigquery-sql': BigQueryColorIcon,
  bigquerySql: BigQueryColorIcon,
  sprites: SpritesLogo,
  stripe: StripeLogo,
  supabase: SupabaseLogo,
  tavily: TavilyLogo,
  weather: WeatherLogo,
  zoom: ZoomLogo,
  telegram: TelegramLogo,
  tiktok: TikTokLogo,
  trustpilot: TrustpilotLogo,
  turbopuffer: TurbopufferLogo,
  twilio: TwilioLogo,
  twitter: TwitterLogo,
  utilities: UtilitiesLogo,
  vapi: VapiLogo,
  youtube: YouTubeLogo,
  'youtube-transcript': YouTubeLogo,
  youtubeTranscript: YouTubeLogo,
  youtubetranscript: YouTubeLogo,
  zendesk: ZendeskLogo,
  vitally: VitallyLogo,
  fireflies: FirefliesLogo,
  zillow: ZillowLogo,
  'reality-defender': RealityDefenderLogo,
  aipercentagedetector: AiPercentageDetectorLogo,
  buffer: BufferLogo,
  webflow: WebflowLogo,
  quo: QuoLogo,
};

export type FilterMode = 'ALL' | 'CONFIGURED' | 'SETUP';

// Curated list of popular/well-known tools
export const POPULAR_TOOL_KEYS = [
  // Customer Support
  'zendesk/tickets/createTickets',
  'zendesk/tickets/updateTickets',
  'kustomer/customers/updateCustomerData',
  'intercom/conversations/addNote',
  'dixa/conversations/addMessage',
  'shopify/customer/getOrdersByEmail',
  // Communication
  'slack/messaging/sendMessage',
  'slack/search/searchMessages',
  // CRM & Sales
  'hubspot/contacts/search',
  'hubspot/companies/search',
  'hubspot/deals/search',
  'salesforce/contacts/findByEmail',
  'salesforce/accounts/findByName',
  'attio/records/search',
  'apollo/search-people',
  // Productivity
  'google-sheets/sheets/readRange',
  'google-sheets/sheets/appendRow',
  'google-sheets/sheets/appendRows',
  'notion/search/query',
  'linear/issue/list',
  'linear/issue/create',
  // Web & Search
  'search-api/google-search',
  'perplexity/chat/completions',
  'firecrawl/extract/sync',
  // Developer
  'github/repos/readFile',
  'github/repos/createPullRequest',
  // Social Listening
  'linkedin/posts/search',
  'linkedin/profile/get',
  'reddit/posts/extractPost',
  'twitter/posts/search',
  'twitter/profile/get',
  // Outreach
  'heyreach/campaigns/addLeads',
  'smartlead/leads/add',
  'smartlead/campaigns/list',
];

export type UseCase = {
  id: string;
  name: string;
  icon: LucideIcon;
  description: string;
  providers: string[];
  /** Optional: specific tool keys for finer-grained control */
  tools?: string[];
};

export const USE_CASES: UseCase[] = [
  {
    id: 'customer-support',
    name: 'Support',
    icon: Headphones,
    description: 'QA, taxonomies, ticket routing, response generation',
    providers: [
      'zendesk',
      'intercom',
      'dixa',
      'gorgias',
      'kustomer',
      'sprout-social',
      'shopify',
      'skio',
      'fcp-euro',
    ],
  },
  {
    id: 'lead-generation',
    name: 'Sales',
    icon: Target,
    description: 'Prospecting, enrichment, email campaigns, CRM management',
    providers: [
      'apollo',
      'hunter',
      'firmable',
      'instantly',
      'smartlead',
      'heyreach',
      'amdahl',
      'hubspot',
      'salesforce',
      'attio',
      'vitally',
      'ocean',
      'cotera',
    ],
  },
  {
    id: 'social-media',
    name: 'Social Media',
    icon: Share2,
    description: 'Track mentions, analyze sentiment, monitor brand presence',
    providers: [
      'linkedin',
      'twitter',
      'reddit',
      'instagram',
      'tiktok',
      'facebook-reviews',
      'poshmark',
    ],
  },
  {
    id: 'data-analysis',
    name: 'Data & Analytics',
    icon: BarChart3,
    description: 'Query databases, run analytics, generate insights',
    providers: [
      'airtable',
      'snowflake-cortex',
      'snowflake-sql',
      'bigquery-sql',
      'supabase',
      'dataset',
      'hex',
      'redash',
      'sigma',
      'python-sandbox',
      'chart-generator',
      'turbopuffer',
      'hyperspell',
      'posthog',
      'google-ads',
      'google-analytics',
      'google-search-console',
    ],
  },
  {
    id: 'web-research',
    name: 'Web & Search',
    icon: Globe,
    description: 'Search, scrape, extract, and monitor web content',
    providers: [
      'google-jobs',
      'google-keyword',
      'google-shopping',
      'perplexity',
      'search-api',
      'firecrawl',
      'site-scraper',
      'backlinks',
      'newsapi',
      'newscatcher',
      'newscatcher-catchall',
      'regulation-asia',
      'similarweb',
      'hacker-news',
    ],
  },
  {
    id: 'content-generation',
    name: 'Content',
    icon: FileText,
    description: 'Create docs, presentations, images, transcripts',
    providers: [
      'google-workspace',
      'notion',
      'gamma',
      'matik',
      'image-generator',
      'agents',
      'fireflies',
      'grain',
      'deepgram',
      'youtube',
      'youtube-transcript',
      'docspring',
      'orshot',
    ],
  },
  {
    id: 'communication',
    name: 'Messaging',
    icon: MessageSquareMore,
    description: 'Send messages, emails, schedule communications',
    providers: [
      'slack',
      'discord',
      'telegram',
      'markdown-email',
      'twilio',
      'vapi',
      'klaviyo',
    ],
  },
  {
    id: 'reviews',
    name: 'Reviews',
    icon: Star,
    description: 'Track reviews, analyze ratings, monitor reputation',
    providers: ['trustpilot', 'glassdoor', 'g2', 'app-reviews'],
    tools: ['google-maps/reviews/getPlaceReviews'],
  },
  {
    id: 'productivity',
    name: 'Productivity',
    icon: Calendar,
    description: 'Calendar, file storage, project tracking',
    providers: ['asana', 'calendly', 'google-sheets', 'linear', 'monday'],
  },
  {
    id: 'developer',
    name: 'Developer',
    icon: Code,
    description: 'Code management, CI/CD, task automation',
    providers: [
      'github',
      'devin',
      'retool',
      'skyvern',
      'modal',
      'sprites',
      'sentry',
    ],
  },
  {
    id: 'location',
    name: 'Location',
    icon: MapPin,
    description: 'Address validation, property data, travel search',
    providers: ['zillow', 'flight-search', 'smarty', 'weather', 'nash'],
    tools: [
      'google-maps/search/searchPlaces',
      'google-maps/address/validate',
      'google-maps/solar/getRoofArea',
    ],
  },
  {
    id: 'financial',
    name: 'Finance',
    icon: Briefcase,
    description: 'SEC filings, company research, payments',
    providers: ['sec', 'ramp', 'snag-solutions', 'stripe', 'orb'],
  },
  {
    id: 'security',
    name: 'Security',
    icon: Shield,
    description: 'AI detection, media verification, fraud prevention',
    providers: ['ai-detector', 'reality-defender'],
  },
];

// Re-export from shared API contract
export {
  NO_AUTH_STRATEGIES,
  CredentialSource,
  isNoAuthStrategy,
} from '@cotera/api';

// Legacy strategies to filter out (explicit list + anything containing "legacy")
export const LEGACY_STRATEGIES = ['tool_by_name'];

/**
 * Maps provider keys to their documentation URL slugs.
 * Most providers use their key directly, but some need special handling.
 */
export const PROVIDER_DOCS_SLUG: Record<string, string | null> = {
  // Providers without public documentation
  cotera: null,
  coteraincludedtools: null,
  utilities: null,
  'fcp-euro': null,
  'google-workspace': null,
  // Provider keys that differ from their docs slug
  agents: 'ai-agents',
  'ai-detector': 'ai-percentage-detector',
  deepgram: 'deepgram',
  flightSearch: 'flight-search',
  google: 'google-search',
  googleJobs: 'google-jobs',
  heyreach: 'hey-reach',
  ocean: 'ocean-io',
  slacksearch: 'slack-search',
  youtubeTranscript: 'youtube-transcript',
};

/**
 * Labels for auth strategy display.
 * 'short' is used for pills in tool accordion items (compact).
 * 'long' is used for toggle selector labels (fuller description).
 */
